import type { TFunction } from 'i18next'

// Mismo listado de orígenes que en CreateEdit Cliente
export const CUSTOMER_ORIGINS = {
  ORGANIC: 'organic',
  STUDENT: 'student',
  AFFILIATE: 'affiliate',
  META_ADS: 'meta_ads',
  LINKEDIN_ADS: 'linkedin_ads',
  GOOGLE_ADS: 'google_ads',
  LINKEDIN: 'linkedin',
  INSTAGRAM: 'instagram',
  BLOG: 'blog',
  INSTAGRAM_PROSPECTING: 'instagram_prospecting',
  LINKEDIN_PROSPECTING: 'linkedin_prospecting',
  COLD_EMAIL: 'cold_email',
  COLD_CALLING: 'cold_calling',
  REFERRAL: 'referral',
  UNKNOWN: 'unknown',
} as const

export type CustomerOrigin = (typeof CUSTOMER_ORIGINS)[keyof typeof CUSTOMER_ORIGINS]

// Orden igual que en el formulario de crear cliente
export const CUSTOMER_ORIGIN_VALUES: CustomerOrigin[] = [
  CUSTOMER_ORIGINS.ORGANIC,
  CUSTOMER_ORIGINS.STUDENT,
  CUSTOMER_ORIGINS.AFFILIATE,
  CUSTOMER_ORIGINS.META_ADS,
  CUSTOMER_ORIGINS.LINKEDIN_ADS,
  CUSTOMER_ORIGINS.GOOGLE_ADS,
  CUSTOMER_ORIGINS.LINKEDIN,
  CUSTOMER_ORIGINS.INSTAGRAM,
  CUSTOMER_ORIGINS.BLOG,
  CUSTOMER_ORIGINS.INSTAGRAM_PROSPECTING,
  CUSTOMER_ORIGINS.LINKEDIN_PROSPECTING,
  CUSTOMER_ORIGINS.COLD_EMAIL,
  CUSTOMER_ORIGINS.COLD_CALLING,
  CUSTOMER_ORIGINS.REFERRAL,
  CUSTOMER_ORIGINS.UNKNOWN,
]

export const customerOriginHelpers = {
  /** Obtiene el label traducido del origen. Usar traducciones de createEditClientsModule */
  getDisplayLabel: (origin: string, t?: TFunction): string => {
    if (t) return t('createEditClientsModule:customerOrigins.' + origin, origin)
    return origin
  },

  /** Alias de getDisplayLabel - misma fuente que crear cliente */
  getSourceLabel: (origin: string, t?: TFunction): string => {
    return customerOriginHelpers.getDisplayLabel(origin, t)
  },

  isValidOrigin: (origin: string): origin is CustomerOrigin => {
    return CUSTOMER_ORIGIN_VALUES.includes(origin as CustomerOrigin)
  },
}
